/*
  YENI TELEFON TASARIMI ANAHTARI ("Secenek A · Lacivert Cam")

  Yeni tasarimin butun parcalari bu anahtara bagli. Anahtar yalnizca
  ONIZLEME derlemesinde acik:

      REACT_APP_YENI_TASARIM=1  ->  build_onizleme  (yalnizca kullanicinin
                                     "Yeni tasarimi dene" dedigi cihazda)
      (bos)                     ->  build            (canli sistem)

  Neden: kullanici gorunum degisikliklerini yayinlanmadan once gormek
  istiyor; bu arada acil duzeltmeler canliya cikmaya devam ediyor. Tasarim
  ayri bir dosya kopyasinda degil kodun icinde dursun ama canli derlemede
  hicbir etkisi olmasin diye her yerde bu sabite bakiliyor. Stil tarafinda
  karsiligi <html class="yeni-tasarim">: styles/mobil-arayuz.css'teki
  butun kurallar bu sinifin altinda.
*/
export const YENI_TASARIM = process.env.REACT_APP_YENI_TASARIM === '1';

/* Onizlemeye gecis isareti (IIS bu cerezi gorunce yeni tasarimin
   dosyalarini sunar; web.config "Onizleme" kurallari). */
export const ONIZLEME_CEREZI = 'lo_onizleme';

export const onizlemeAcikMi = () => {
  try {
    return document.cookie.split(';').some((c) => c.trim() === `${ONIZLEME_CEREZI}=1`);
  } catch (e) {
    return false;
  }
};

/** Bu cihazda yeni tasarimi acar ya da kapatir; sayfa bastan yuklenir. */
export const onizlemeyiAyarla = (acik) => {
  const gun = 30 * 24 * 60 * 60;
  document.cookie = acik
    ? `${ONIZLEME_CEREZI}=1; path=/; max-age=${gun}; secure; samesite=lax`
    : `${ONIZLEME_CEREZI}=; path=/; max-age=0; secure; samesite=lax`;
  // Sunucudan yeni tasarimin dosyalari gelsin diye ana sayfadan baslat.
  window.location.replace('/dashboard');
};
